import '../../style/index.less';
import './index.less'; // style dependencies

import '../../empty/style';
import '../../checkbox/style';
import '../../button/style';
import '../../input/style';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/transfer/style/index.js
// module id = 1920
// module chunks = 0